import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useFindInvoicesByOrganizationId } from "~/gen/api"
import { InvoicesAdmin } from "~/pages/Admin/Invoices/InvoicesAdmin"

export const InvoicesAdminWrapper = () => {
  const invoicesQuery = useFindInvoicesByOrganizationId()

  return (
    <DataFetchWrapper query={invoicesQuery} acceptEmpty={true}>
      {({ data }) => <InvoicesAdmin invoices={data.data ?? []} />}
    </DataFetchWrapper>
  )
}
